import * as MEDICINE from '@/store/constants/medicine';

export default {
  [MEDICINE.GET_MEDICINE_LIST]: (state) => {
    return state.list;
  }
}


// WEBPACK FOOTER //
// ./src/store/medicine/getters.js